// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audience-explore{\n    padding: 0px 30px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    border-left:1px solid rgb(230, 222, 222); ;\n    \n    \n}\n  .ant-table-body{\nborder: 1px solid rgb(230, 222, 222);\noverflow: hidden;\ncursor: pointer;\n  }\n  \n  ", ""]);
// Exports
module.exports = exports;
